/**
 * Shared task assignment form used by queues and review cards.
 */
import { getDashboardOperator } from "./dashboard-auth.js";
import { escapeAttr } from "./dashboard-html.js";
import type { LeadFactoryTask } from "./dashboard-lead-factory-types.js";

export function taskAssignmentFormHtml(task: LeadFactoryTask): string {
  if (!["open", "assigned", "blocked"].includes(task.status)) return "";
  return `
    <form class="structured-action-form task-assignment-form" data-task-assign-form data-task-id="${escapeAttr(task.id)}" data-task-status="${escapeAttr(task.status)}">
      <input type="text" maxlength="120" value="${escapeAttr(task.assigned_to || getDashboardOperator())}" aria-label="Assign task to" data-task-assignee-input>
      <button class="button secondary" type="submit">Assign</button>
    </form>
  `;
}

